export default class Form {

  constructor(form) {

    this.form = form;
    this.inputFields = '';
    this.currentForm = '';
    this.proceed = true;

    this.init();
  }

  /**
   * Initialize for each Form
   */
  init() {
    this.inputFields = this.form.querySelectorAll('[name]:not([type="hidden"])');

    if (!this.inputFields || '' === this.inputFields) {
      return;
    }

    for (let input of this.inputFields) {
      input.addEventListener("focus", this.onFocus.bind(this), true);
      input.addEventListener("blur", this.onBlur.bind(this), true);

      // On load.
      this.onValidate(input);

      // Set max on select['multiple'][data-max-length']
      if ('SELECT' === input.nodeName && input.multiple && input.dataset.maxLength) {
        this.selectMultipleMax(input, parseFloat(input.dataset.maxLength));
      }
    }

  }

  // Validate input fields
  onValidate(input) {
    let parent = input.parentNode.parentNode;

    if (parent.classList.contains('ginput_complex') || parent.classList.contains('clear-multi')) {
      parent = input.parentNode;
    }

    if (parent.classList.contains('is-focus') && !input.value) {
      parent.classList.remove('is-focus');
    }

    if (input.tagName === 'SELECT' && input.value.trim()) {
      parent.classList.add('is-focus');
    }

    if (parent.classList.contains('is-invalid')) {
      parent.classList.remove('is-invalid');
    }

    if (!input.value) {
      parent.classList.remove('is-valid');
      return;
    }

    if (input.checkValidity()) {
      // use Pattern HTML attribute
      parent.classList.add('is-valid');

      if (!parent.classList.contains('is-focus')) {
        parent.classList.add('is-focus');
      }

      if (parent.classList.contains('gfield_error')) {
        parent.classList.remove('gfield_error');
      }
    } else {
      parent.classList.remove('is-valid');
      parent.classList.add('is-invalid');
    }
  }

  // Add action onFocus
  onFocus(event) {
    let parent = event.target.parentNode.parentNode;
    if (parent.classList.contains('ginput_complex') || parent.classList.contains('clear-multi')) {
      parent = event.target.parentNode;
    }

    parent.classList.add('is-focus');
  }

  // Add action onBlur
  onBlur(event) {
    this.onValidate(event.target);
  }

  // Select multiple max behaviour
  selectMultipleMax(element, maxSelected) {
    const counter_id = element.getAttribute('id').replace('input', 'counter');

    element.addEventListener('change', (e) => {

      // Get amount of selected options
      let amountSelected = Array.from(element.options).filter(function (option) {
        return option.selected;
      }).map(function (option) {
        return option.value;
      });

      // remove selected if there're tomuch selected options
      if (amountSelected.length > maxSelected) {

        const values = jQuery(element).val().toString().split(',');

        // Unset maxSelected
        jQuery('option[value="' + values[maxSelected] + '"]').prop('selected', false);

        // Unset a option after maxSelected
        for (let i = maxSelected, j = amountSelected.length; i < j; i++) {
          jQuery('option[value="' + values[i] + '"]').prop('selected', false);
        }
      }

      // Update counter
      const counter = document.getElementById(counter_id);
      if (counter) {
        counter.innerHTML = (
          amountSelected.length <= maxSelected
            ? amountSelected.length
            : maxSelected
        );
      }
    });
  }
}
